module.exports = __webpack_public_path__ + "static/media/image-3.ed45e846.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/CovidSocial/image-3.png
// module id = 456
// module chunks = 0